import React, { useMemo, useState } from "react";
import Box from "@mui/material/Box";
import {
  DataGrid,
  gridClasses,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import * as XLSX from "xlsx";

const SRATable = ({ sras, activeTab, isLoading }) => {
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const dashboard = JSON.parse(localStorage.getItem("dashboard"));

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const columns = [
    {
      field: "id",
      headerName: "Request No.",
      flex: 1.2,
      renderCell: (params) => (
        <span
          style={{ fontWeight: "bold", fontSize: "12px" }}
          className="table-title"
        >
          {dashboard === "SERVICE"
            ? params.row.sraId
            : dashboard === "INVOICE"
              ? params.row.invoiceId
              : dashboard === "CUSTOMER"
                ? params.row.customerId
                : dashboard === "VENDOR_APPROVAL"
                  ? params.row.vendorId
                  : dashboard === "TRADE"
                    ? params.row.tradeId
                    : dashboard === "VENDOR"
                      ? params.row.vendorBalanceId
                      : dashboard === "CUSTOMER_BALANCE"
                        ? params.row.customerBalanceId
                        : dashboard === "ADVANCE"
                          ? params.row.advanceId
                          : dashboard === "DEPOSIT"
                            ? params.row.depositId
                            : dashboard === "OTHER"
                              ? params.row.otherId
                              : dashboard === "CUSTOMER_DEPOSIT"
                                ? params.row.customerDepositId
                                : dashboard === "TENDER_DEPOSIT"
                                  ? params.row.tenderDepositId
                                  : dashboard === "VENDOR_ADVANCE"
                                    ? params.row.vendorAdvanceId
                                    : dashboard === "INVENTORY"
                                      ? params.row.inventoryId
                                      : params.row.id}
        </span>
      ),
    },
    {
      field: "title",
      headerName: "Title",
      flex: 1,
    },
    {
      field: "category",
      headerName: "Category",
      flex: 1,
      renderCell: (params) => (
        <span>
          {dashboard === "SERVICE"
            ? "Service Order"
            : dashboard === "INVOICE"
              ? "Invoice Approval"
              : dashboard === "CUSTOMER"
                ? "New Customer Approval"
                : dashboard === "VENDOR_APPROVAL"
                  ? "New Vendor Approval"
                  : dashboard === "TRADE"
                    ? "Trade Markeitng Approval"
                    : dashboard === "VENDOR"
                      ? `Write ${params.row.writeType} - Vendor Balance`
                      : dashboard === "CUSTOMER_BALANCE"
                        ? `Write ${params.row.writeType} - Customer Balance`
                        : dashboard === "ADVANCE"
                          ? `Write ${params.row.writeType} - Advances Given`
                          : dashboard === "DEPOSIT"
                            ? `Write ${params.row.writeType} - Deposit Given`
                            : dashboard === "INVENTORY"
                              ? `Write ${params.row.writeType} - Inventory`
                              : dashboard === "OTHER"
                                ? `Write ${params.row.writeType} - Others`
                                : dashboard === "CUSTOMER_DEPOSIT"
                                  ? "Customer Deposit"
                                  : dashboard === "TENDER_DEPOSIT"
                                    ? "Tender Deposit"
                                    : dashboard === "VENDOR_ADVANCE"
                                      ? "Vendor Advance"
                                      : params.row.id.includes("WOVB") ||
                                          params.row.id.includes("WBVB")
                                        ? `Write ${params.row.writeType} - Vendor Balance`
                                        : params.row.id.includes("WOCB") ||
                                            params.row.id.includes("WBCB")
                                          ? `Write ${params.row.writeType} - Customer Balance`
                                          : params.row.id.includes("WOAG") ||
                                              params.row.id.includes("WBAG")
                                            ? `Write ${params.row.writeType} - Advances Given`
                                            : params.row.id.includes("WODG") ||
                                                params.row.id.includes("WBDG")
                                              ? `Write ${params.row.writeType} - Deposit Given`
                                              : params.row.id.includes("WOI") ||
                                                  params.row.id.includes("WBI")
                                                ? `Write ${params.row.writeType} - Inventory`
                                                : params.row.id.includes(
                                                      "WOO",
                                                    ) ||
                                                    params.row.id.includes(
                                                      "WBO",
                                                    )
                                                  ? `Write ${params.row.writeType} - Others`
                                                  : params.row.id.includes("CA")
                                                    ? "New Customer Approval"
                                                    : params.row.id.includes(
                                                          "VA",
                                                        )
                                                      ? "New Vendor Approval"
                                                      : params.row.id.includes(
                                                            "IA",
                                                          )
                                                        ? "Invoice Approval"
                                                        : params.row.id.includes(
                                                              "TM",
                                                            )
                                                          ? "Trade Marketing Scheme"
                                                          : params.row.id.includes(
                                                                "CD",
                                                              )
                                                            ? "Customer Deposit"
                                                            : params.row.id.includes(
                                                                  "TD",
                                                                )
                                                              ? "Tender Deposit"
                                                              : params.row.id.includes(
                                                                    "VAD",
                                                                  )
                                                                ? "Vendor Advance"
                                                                : "Service Order"}
        </span>
      ),
    },
    {
      field: "requester",
      headerName: "Requester",
      flex: 1,
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      flex: 1,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1.3,
      renderCell: (params) => {
        const statusColors = {
          PENDING: "#FFCD82",
          APPROVED: "#35D85B",
          PROCEEDED: "#35D85B",
          PAID: "#35D85B",
          QUERY: "#EA981F",
          REJECTED: "#FA6459",
        };

        const statusLabels = {
          PENDING: "PENDING",
          APPROVED: "APPROVED",
          QUERY: "QUERY",
          REJECTED: "REJECTED",
          PROCEEDED: "PROCESSED",
          PAID: "PAID",
        };

        return (
          <span
            style={{
              background: statusColors[params.row.status],
              borderRadius: "15px",
              padding: "5px 15px",
              fontWeight: 600,
            }}
          >
            {params.row.status
              ? activeTab === "APPROVED" && params.row.status === "PENDING"
                ? `APPROVED BY ${params.row.stage - 1}/${params.row.numberOfApprovers}`
                : activeTab === "APPROVED" && params.row.status === "QUERY"
                  ? `QUERY BY APPROVER ${params.row.stage}`
                  : statusLabels[params.row.status]
              : ""}
          </span>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ display: "inline-flex", gap: 1 }}>
          <Button
            className="btn-outlined"
            sx={{
              margin: "0 !important",
              padding: "0 !important",
              width: "auto !important",
            }}
            onClick={() => {
              localStorage.setItem("activeTab", activeTab);
              if (dashboard === "SERVICE") {
                navigate(`/dashboard/${params.row.sraId}`);
              } else if (dashboard === "INVOICE") {
                navigate(`/dashboard/${params.row.invoiceId}`);
              } else if (dashboard === "CUSTOMER") {
                navigate(`/dashboard/${params.row.customerId}`);
              } else if (dashboard === "VENDOR_APPROVAL") {
                navigate(`/dashboard/${params.row.vendorId}`);
              } else if (dashboard === "TRADE") {
                navigate(`/dashboard/${params.row.tradeId}`);
              } else if (dashboard === "VENDOR") {
                navigate(`/dashboard/${params.row.vendorBalanceId}`);
              } else if (dashboard === "CUSTOMER_BALANCE") {
                navigate(`/dashboard/${params.row.customerBalanceId}`);
              } else if (dashboard === "ADVANCE") {
                navigate(`/dashboard/${params.row.advanceId}`);
              } else if (dashboard === "DEPOSIT") {
                navigate(`/dashboard/${params.row.depositId}`);
              } else if (dashboard === "OTHER") {
                navigate(`/dashboard/${params.row.otherId}`);
              } else if (dashboard === "CUSTOMER_DEPOSIT") {
                navigate(`/dashboard/${params.row.customerDepositId}`);
              } else if (dashboard === "TENDER_DEPOSIT") {
                navigate(`/dashboard/${params.row.tenderDepositId}`);
              } else if (dashboard === "VENDOR_ADVANCE") {
                navigate(`/dashboard/${params.row.vendorAdvanceId}`);
              } else if (dashboard === "INVENTORY") {
                navigate(`/dashboard/${params.row.inventoryId}`);
              } else {
                navigate(`/dashboard/${params.row.id}`);
              }
            }}
          >
            View
          </Button>

          {activeTab === "QUERY" && storedUser.userRole[0] === "BUYER" && (
            <Button
              className="btn-outlined"
              sx={{
                margin: "0 !important",
                padding: "0 !important",
                width: "auto !important",
              }}
              onClick={() => {
                localStorage.setItem("activeTab", activeTab);
                if (dashboard === "SERVICE") {
                  navigate(`/dashboard/edit-service-order/${params.row.sraId}`);
                } else if (dashboard === "INVOICE") {
                  navigate(
                    `/dashboard/edit-invoice-approval/${params.row.invoiceId}`,
                  );
                } else if (dashboard === "CUSTOMER") {
                  navigate(
                    `/dashboard/edit-customer-approval/${params.row.customerId}`,
                  );
                } else if (dashboard === "VENDOR_APPROVAL") {
                  navigate(
                    `/dashboard/edit-vendor-approval/${params.row.vendorId}`,
                  );
                } else if (dashboard === "TRADE") {
                  navigate(`/dashboard/edit-trade/${params.row.tradeId}`);
                } else if (dashboard === "VENDOR") {
                  navigate(
                    `/dashboard/edit-vendor-balance/${params.row.vendorBalanceId}`,
                  );
                } else if (dashboard === "CUSTOMER_BALANCE") {
                  navigate(
                    `/dashboard/edit-customer-balance/${params.row.customerBalanceId}`,
                  );
                } else if (dashboard === "ADVANCE") {
                  navigate(
                    `/dashboard/edit-advance-given/${params.row.advanceId}`,
                  );
                } else if (dashboard === "DEPOSIT") {
                  navigate(
                    `/dashboard/edit-deposit-given/${params.row.depositId}`,
                  );
                } else if (dashboard === "OTHER") {
                  navigate(`/dashboard/edit-other/${params.row.otherId}`);
                } else if (dashboard === "CUSTOMER_DEPOSIT") {
                  navigate(
                    `/dashboard/edit-customer-deposit/${params.row.customerDepositId}`,
                  );
                } else if (dashboard === "TENDER_DEPOSIT") {
                  navigate(
                    `/dashboard/edit-tender-deposit/${params.row.tenderDepositId}`,
                  );
                } else if (dashboard === "VENDOR_ADVANCE") {
                  navigate(
                    `/dashboard/edit-vendor-advance/${params.row.vendorAdvanceId}`,
                  );
                } else if (dashboard === "INVENTORY") {
                  navigate(
                    `/dashboard/edit-inventory/${params.row.inventoryId}`,
                  );
                } else {
                  navigate(`/dashboard/${params.row.id}`);
                }
              }}
            >
              Edit
            </Button>
          )}
        </Box>
      ),
    },
  ].filter(Boolean);

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-");
    const cleanTime = time?.split(".")[0];
    return `${day}/${month}/${year} ${cleanTime}`;
  };

  const rows =
    sras &&
    sras.map((sra) => {
      const dynamicId =
        dashboard === "SERVICE"
          ? sra.sraId
          : dashboard === "INVOICE"
            ? sra.invoiceId
            : dashboard === "CUSTOMER"
              ? sra.customerId
              : dashboard === "VENDOR_APPROVAL"
                ? sra.vendorId
                : dashboard === "TRADE"
                  ? sra.tradeId
                  : dashboard === "VENDOR"
                    ? sra.vendorBalanceId
                    : dashboard === "CUSTOMER_BALANCE"
                      ? sra.customerBalanceId
                      : dashboard === "ADVANCE"
                        ? sra.advanceId
                        : dashboard === "DEPOSIT"
                          ? sra.depositId
                          : dashboard === "OTHER"
                            ? sra.otherId
                            : dashboard === "CUSTOMER_DEPOSIT"
                              ? sra.customerDepositId
                              : dashboard === "TENDER_DEPOSIT"
                                ? sra.tenderDepositId
                                : dashboard === "VENDOR_ADVANCE"
                                  ? sra.vendorAdvanceId
                                  : dashboard === "INVENTORY"
                                    ? sra.inventoryId
                                    : sra.id;

      return {
        ...sra,
        id: dynamicId,
        startDate: formatDateTime(sra.startDate),
        endDate: formatDateTime(sra.endDate),
        createdDate: formatDateTime(sra.createdDate),
        rawCreatedDate: sra.createdDate,
      };
    });

  const filteredRows = useMemo(() => {
    return (rows || []).filter((row) => {
      if (!row.rawCreatedDate) return false;

      const rowDate = new Date(row.rawCreatedDate);
      const from = fromDate ? new Date(fromDate + "T00:00:00") : null;
      const to = toDate ? new Date(toDate + "T23:59:59") : null;

      if (from && rowDate < from) return false;
      if (to && rowDate > to) return false;

      return true;
    });
  }, [rows, fromDate, toDate]);

  const handleExport = () => {
    let exportData = [];

    if (dashboard === "SERVICE") {
      exportData = filteredRows.map((row) => ({
        "Start Date": row.startDate || "",
        "End Date": row.endDate || "",
        "Basic Amount": row.planningAmount || "",
        "Tax Amount": row.tax || "",
        Other: row.other || "",
        "Total Amount": row.amount || "",
        "Vendor Code": row.vendorCode || "",
        "Vendor Name": row.vendorName || "",
        "Plant Name": row.plantDetails?.name || "",
        "Plant GST": row.plantDetails?.gst || "",
        "Plant Address": row.plantDetails?.address || "",
        GL: row.gl || "",
        "Cost Center": row.costCenter || "",
        Status: row.status || "",
        "AMS Request No.": row.id || "",
        Title: row.title || "",
      }));
    } else if (dashboard === "INVOICE") {
      exportData = filteredRows.map((row) => ({
        "Invoice Number": row.number || "",
        "Invoice Date": formatDateTime(row.date) || "",
        "Invoice Value Including GST": row.amount || "",
        "Vendor Code": row.vendorCode || "",
        "Vendor Name": row.vendorName || "",
        "PO/Service": row.po || "",
        GL: row.gl || "",
        "Cost Center": row.costCenter || "",
        "SAP Document Number": row?.processedSap || "",
        Status: row.status || "",
        "AMS Request No.": row.id || "",
        "Due Date of Payment": formatDateTime(row.dueDate) || "",
        Title: row.title || "",
      }));
    } else if (dashboard === "VENDOR_ADVANCE") {
      exportData = filteredRows.map((row) => ({
        "AMS Request No.": row.id || "",
        Status: row.status || "",
        "Proforma ID": row.proformaId || "",
        "Date of Proforma ID": formatDateTime(row.date) || "",
        "Advance Amount": row.advAmount || "",
        "Bank Details": row.details || "",
        "Payment Terms": row.paymentTerms || "",
        "Vendor Name": row.name || "",
        "Vendor Code": row.code || "",
        Title: row.title || "",
      }));
    } else {
      exportData = filteredRows.map((row) => ({
        "Request No.": row.id || "",
        Title: row.title || "",
        Category:
          dashboard === "INVOICE"
            ? "Invoice Approval"
            : dashboard === "CUSTOMER"
              ? "New Customer Approval"
              : dashboard === "VENDOR_APPROVAL"
                ? "New Vendor Approval"
                : dashboard === "TRADE"
                  ? "Trade Marketing Approval"
                  : dashboard === "VENDOR"
                    ? `Write ${row.writeType} - Vendor Balance`
                    : dashboard === "CUSTOMER_BALANCE"
                      ? `Write ${row.writeType} - Customer Balance`
                      : dashboard === "ADVANCE"
                        ? `Write ${row.writeType} - Advances Given`
                        : dashboard === "DEPOSIT"
                          ? `Write ${row.writeType} - Deposit Given`
                          : dashboard === "INVENTORY"
                            ? `Write ${row.writeType} - Inventory`
                            : dashboard === "OTHER"
                              ? `Write ${row.writeType} - Others`
                              : dashboard === "CUSTOMER_DEPOSIT"
                                ? "Customer Deposit"
                                : dashboard === "TENDER_DEPOSIT"
                                  ? "Tender Deposit"
                                  : dashboard === "VENDOR_ADVANCE"
                                    ? "Vendor Advance"
                                    : "",
        Requester: row.requester || "",
        "Created Date": row.createdDate || "",
        Status: row.status || "",
      }));
    }

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "SRA Data");

    const fileName = `${dashboard || "data"}_${
      fromDate || "all"
    }_${toDate || "all"}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };

  return (
    <Box sx={{ width: "100%", minHeight: "400px" }}>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          alignItems: "center",
          justifyContent: "flex-end",
          mb: 2,
          flexWrap: "wrap",
        }}
      >
        <Box>
          <label style={{ display: "block", marginBottom: 4 }}>From</label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            style={{
              border: "1px solid #B0B0B0",
              borderRadius: "10px",
              padding: "8px 12px",
            }}
          />
        </Box>

        <Box>
          <label style={{ display: "block", marginBottom: 4 }}>To</label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            style={{
              border: "1px solid #B0B0B0",
              borderRadius: "10px",
              padding: "8px 12px",
            }}
          />
        </Box>

        <Button
          className="btn-outlined"
          onClick={() => {
            setFromDate("");
            setToDate("");
          }}
        >
          Clear
        </Button>

        <Button className="btn-contained" onClick={handleExport}>
          Export Excel
        </Button>
      </Box>

      <DataGrid
        rows={filteredRows}
        columns={columns}
        loading={isLoading}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10]}
        disableRowSelectionOnClick
        disableColumnSelector
        disableDensitySelector
        disableColumnMenu
        disableColumnResize
        slots={{ toolbar: CustomToolbar }}
        getRowId={(row) =>
          dashboard === "SERVICE"
            ? row.sraId
            : dashboard === "INVOICE"
              ? row.invoiceId
              : dashboard === "CUSTOMER"
                ? row.customerId
                : dashboard === "VENDOR_APPROVAL"
                  ? row.vendorId
                  : dashboard === "TRADE"
                    ? row.tradeId
                    : dashboard === "VENDOR"
                      ? row.vendorBalanceId
                      : dashboard === "CUSTOMER_BALANCE"
                        ? row.customerBalanceId
                        : dashboard === "ADVANCE"
                          ? row.advanceId
                          : dashboard === "DEPOSIT"
                            ? row.depositId
                            : dashboard === "OTHER"
                              ? row.otherId
                              : dashboard === "CUSTOMER_DEPOSIT"
                                ? row.customerDepositId
                                : dashboard === "TENDER_DEPOSIT"
                                  ? row.tenderDepositId
                                  : dashboard === "VENDOR_ADVANCE"
                                    ? row.vendorAdvanceId
                                    : dashboard === "INVENTORY"
                                      ? row.inventoryId
                                      : row.id
        }
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        sx={{
          position: "relative",
          border: "none",
          fontFamily: "Inter !important",
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "700 !important",
          },
          "& .MuiDataGrid-columnHeaders": {
            background: "none !important",
            color: "black",
            fontSize: "14px",
            borderRadius: "10px",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#fff",
          },
          "& .MuiDataGrid-cell": {
            fontSize: "13px",
            border: "none",
          },
          "& .MuiDataGrid-columnSeparator": {
            display: "none",
          },
          "& .css-1ccsd5i-MuiButtonBase-root-MuiButton-root": {
            color: "#000 !important",
            border: "1px solid #B0B0B0",
            borderRadius: "12px",
            padding: 1,
          },
          "& .MuiInputBase-root-MuiInput-root::after": {
            borderBottom: "none !important",
          },
          "& .MuiInputBase-root-MuiInput-root": {
            borderBottom: "none !important",
          },
          [`& .${gridClasses.row}.even`]: {
            backgroundColor: "#EAF4FF",
          },
          "& .MuiInput-underline:before": {
            borderBottom: "none !important",
          },
          "& .css-5h82ro-MuiInputBase-root-MuiInput-root::after": {
            borderBottom: "none !important",
          },
        }}
      />
    </Box>
  );
};

export default SRATable;

function CustomToolbar() {
  return (
    <GridToolbarContainer sx={{ display: "flex", justifyContent: "end" }}>
      <GridToolbarQuickFilter
        sx={{
          border: "1px solid #B0B0B0",
          borderRadius: "12px",
          padding: "4px 12px",
          "&:hover": {
            backgroundColor: "#D8E9F0",
          },
          "& .MuiInputBase-root": {
            borderRadius: "12px",
          },
          width: 300,
        }}
      />
    </GridToolbarContainer>
  );
}
